
// Permit Types
export const OVERNIGHT_EXITING_MT_WHITNEY_KEY = 'overnight-exiting-mt-whitney';
export const OVERNIGHT_PERMIT_KEY = 'overnight-permit';
export const OVERNIGHT_EXITING_MT_WHITNEY_SIERRA_KEY = 'overnight-exiting-mt-whitney-2';

export const PERMIT_TYPE_LIST = {
  default: OVERNIGHT_PERMIT_KEY,
  [OVERNIGHT_PERMIT_KEY]: 'Overnight',
  [OVERNIGHT_EXITING_MT_WHITNEY_KEY]: 'Overnight Exiting Mt Whitney',
  [OVERNIGHT_EXITING_MT_WHITNEY_SIERRA_KEY]: 'Overnight Exiting Mt Whitney'
};

export const INYO_GROUPSIZE_MAX_PERMIT_TYPE = {
  [OVERNIGHT_EXITING_MT_WHITNEY_KEY]: 15,
  [OVERNIGHT_PERMIT_KEY]: 15
};

export const MAP_INYO_PERMIT = {
  Overnight: OVERNIGHT_PERMIT_KEY,
  OvernightExitingMtWhitney: OVERNIGHT_EXITING_MT_WHITNEY_KEY
}
